import { render, staticRenderFns } from "./Tasklist.vue?vue&type=template&id=79db88f6&scoped=true"
import script from "./Tasklist.vue?vue&type=script&lang=js"
export * from "./Tasklist.vue?vue&type=script&lang=js"
import style0 from "./Tasklist.vue?vue&type=style&index=0&id=79db88f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79db88f6",
  null
  
)

export default component.exports